import { createFileRoute } from "@tanstack/react-router";
import { useProfile, useReferrals } from "@/lib/data-hooks";
import { StatCard } from "@/components/app/stat-card";
import { Users, DollarSign, Link as LinkIcon, Copy } from "lucide-react";
import { fmtMoney } from "@/lib/format";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

export const Route = createFileRoute("/_authenticated/referrals")({
  head: () => ({ meta: [{ title: "Referrals — CryptoBull Pro" }] }),
  component: Referrals,
});

function Referrals() {
  const { data: profile } = useProfile();
  const { data: refs = [] } = useReferrals();
  const referralLink = profile?.referral_code
    ? `${typeof window !== "undefined" ? window.location.origin : ""}/auth?ref=${profile.referral_code}`
    : "";

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-semibold">Referral program</h1>
        <p className="text-sm text-muted-foreground">Earn 5% commission on every deposit from your referrals.</p>
      </div>

      <div className="grid sm:grid-cols-3 gap-4">
        <StatCard label="Total Referrals" value={String(refs.length)} icon={Users} accent="primary" />
        <StatCard label="Referral Earnings" value={fmtMoney(profile?.referral_earnings)} icon={DollarSign} accent="gold" />
        <StatCard label="Active Code" value={profile?.referral_code ?? "—"} icon={LinkIcon} accent="success" />
      </div>

      <div className="glass rounded-2xl p-6">
        <div className="text-sm text-muted-foreground">Your referral link</div>
        <div className="mt-2 flex gap-2">
          <code className="flex-1 rounded-md bg-white/5 px-3 py-2 text-xs font-mono break-all">{referralLink}</code>
          <Button variant="outline" size="sm" onClick={() => { navigator.clipboard.writeText(referralLink); toast.success("Copied!"); }}><Copy className="h-4 w-4" /></Button>
        </div>
      </div>

      <div className="glass rounded-2xl p-6">
        <div className="text-sm font-medium mb-4">Your referrals</div>
        {refs.length === 0 ? <div className="text-sm text-muted-foreground py-6 text-center">No referrals yet — share your link!</div> : (
          <div className="space-y-2">
            {refs.map((r) => (
              <div key={r.id} className="flex items-center justify-between rounded-lg px-3 py-2 hover:bg-white/5">
                <div>
                  <div className="text-sm">{r.referee?.full_name ?? r.referee?.email ?? "User"}</div>
                  <div className="text-[11px] text-muted-foreground">Deposited {fmtMoney(r.referee?.total_deposited)}</div>
                </div>
                <div className="font-mono text-sm text-amber-300">+{fmtMoney(r.commission)}</div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}